import { FormBase } from 'core/components';

export default class FacilityOrderExtraSuppliesAddForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'subCategoryId',
                    label: 'FACILITY_ORDER_TEMPLATE.NEW_FACILITY_ORDER_TEMPLATE.SUB_CATEGORY_NAME_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.NEW_FACILITY_ORDER_TEMPLATE.SUB_CATEGORY_NAME_PLACEHOLDER',
                    rules: 'required|string'                
                },
            ],
        };
    }
}
